/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 12:45 PM
 *
 */

import Wrapper from 'components/layout/Wrapper/Wrapper';

export default Wrapper;
